import { ModuleWithProviders, NgModule } from '@angular/core';

import { DataMartApiConfiguration, IDataMartApiConfiguration } from './data-mart-api-configuration';

@NgModule()
export class DataMartApiModule {
  static forRoot(params: IDataMartApiConfiguration): ModuleWithProviders<DataMartApiModule> {
    return {
      ngModule: DataMartApiModule,
      providers: [{ provide: DataMartApiConfiguration, useValue: params }],
    };
  }
}
